import React from "react";
import Tablefilter from "../../../common/Tablefilter";

/**
 * Filter dropdowns (intake, campus, delivery method, grades, version) for the linked programmes toolbar — same Tablefilter component/behaviour used elsewhere (e.g. Career Library's table).
 * @param {{arr: Array, checkObj: Object}} intake Selected filter state for `intake`, `campus`, `delivery`, `gradesLocked` and `version`, each paired with a `set<Name>` setter.
 * @param {Object} dropdown Options for each filter dropdown.
 * @param {boolean} isProcessing Whether a bulk action is running.
 * @param {boolean} isVersionEnabled Whether the version filter is shown.
 * @param {Function} setPage Resets pagination on filter change.
 */
function LinkedProgrammeFilters({
    intake,
    setIntake,
    campus,
    setCampus,
    delivery,
    setDelivery,
    gradesLocked,
    setGradesLocked,
    version,
    setVersion,
    dropdown,
    isProcessing,
    isVersionEnabled,
    setPage,
}) {
    const withPageReset = (setter) => (nextState) => {
        setter(nextState);
        setPage(1);
    };

    return (
        <>
            <Tablefilter
                filterName="Intake"
                optionArr={dropdown.intake}
                state={intake}
                setState={withPageReset(setIntake)}
                uniqueId="intake"
                isOptionReversed
                isDisabled={isProcessing}
            />

            <Tablefilter
                filterName="Campus"
                optionArr={dropdown.campus}
                state={campus}
                setState={withPageReset(setCampus)}
                uniqueId="lpCampus"
                isDisabled={isProcessing}
            />

            <Tablefilter
                filterName="Method"
                optionArr={dropdown.deliveryMethod}
                state={delivery}
                setState={withPageReset(setDelivery)}
                uniqueId="method"
                isDisabled={isProcessing}
            />

            <Tablefilter
                filterName="Grades"
                optionArr={[
                    { value: 1, label: "Locked" },
                    { value: 0, label: "Unlocked" },
                ]}
                state={gradesLocked}
                setState={withPageReset(setGradesLocked)}
                uniqueId="gradesLocked"
                isDisabled={isProcessing}
            />

            {isVersionEnabled && (
                <Tablefilter
                    filterName="Version"
                    optionArr={dropdown.versionFilters}
                    state={version}
                    setState={withPageReset(setVersion)}
                    uniqueId="version"
                    isDisabled={isProcessing}
                />
            )}
        </>
    );
}

export default LinkedProgrammeFilters;
